angular.module 'zc.projects'

.directive 'projectsMenuSearch', ($state, $timeout, Project, Devise) ->
  directive =
    restrict: "EA"
    scope: {}
    replace: true
    templateUrl: '/templates/projects/views/directives/projects_menu_search.html'
    link: (scope, element) ->
      scope.Project = Project
      scope.Devise = Devise
      
      scope.focusOnSearch = () ->
        # use timeout because otherwise gets called too early
        # (when dropdown not yet visible) >_<
        $timeout () ->
          input = element.find("input.project-search")
          input.focus()
        , 50
        # explicit return required, otherwise angular throws error
        # see: https://groups.google.com/forum/#!topic/angular/bsTbZ86WAY4
        return
        
      scope.goHome = (project) ->
        scope.Project.goHome(project)



  directive



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects/directives/projects/projects_menu_search.coffee